import React, { useState, useEffect } from "react";
import questionsData from "../data/questions";
import QuestionCard from "./QuestionCard";
import Result from "./Result";
import "./Quiz.css";

const getRandomQuestions = (allQuestions, count = 10) => {
  const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const Quiz = () => {
  const [questions, setQuestions] = useState(
    getRandomQuestions(questionsData)
  );
  const [currentIndex, setCurrentIndex] = useState(0);

  // Holds current answer (string | array)
  const [userAnswer, setUserAnswer] = useState("");

  // Stores all answers for review
  const [userAnswers, setUserAnswers] = useState([]);

  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(40); // seconds per question
  useEffect(() => {
  if (showResult) return;

  if (timeLeft === 0) {
    handleNext(); // auto move to next question
    return;
  }

  const timer = setTimeout(() => {
    setTimeLeft((prev) => prev - 1);
  }, 1000);

  return () => clearTimeout(timer);
}, [timeLeft, showResult]);

  const handleNext = () => {
  const currentQuestion = questions[currentIndex];
  let isCorrect = false;

  /* ---------- CHECK ANSWER SAFELY ---------- */

  if (currentQuestion.type === "fill") {
    if (typeof userAnswer === "string") {
      isCorrect =
        userAnswer.trim().toLowerCase() ===
        String(currentQuestion.answer).trim().toLowerCase();
    }
  }

  if (currentQuestion.type === "single") {
    isCorrect = userAnswer === currentQuestion.answer;
  }

  if (currentQuestion.type === "multi") {
    if (Array.isArray(userAnswer)) {
      const sortedUser = [...userAnswer].sort();
      const sortedCorrect = [...currentQuestion.answer].sort();

      isCorrect =
        sortedUser.length === sortedCorrect.length &&
        sortedUser.every((val, idx) => val === sortedCorrect[idx]);
    }
  }

  /* ---------- SCORE ---------- */
  if (isCorrect) {
    setScore((prev) => prev + 1);
  }

  /* ---------- SAVE FOR REVIEW ---------- */
  setUserAnswers((prev) => [
    ...prev,
    {
      question: currentQuestion.question,
      userAnswer:
        Array.isArray(userAnswer) ? [...userAnswer] : userAnswer || "",
      correctAnswer: currentQuestion.answer,
      tags: currentQuestion.tags || [],
      isCorrect,
    },
  ]);

  /* ---------- TRANSITION ---------- */
  setIsTransitioning(true);

  setTimeout(() => {
    // Reset answer properly based on type
    if (currentQuestion.type === "multi") {
      setUserAnswer([]);
    } else {
      setUserAnswer("");
    }

    if (currentIndex + 1 < questions.length) {
      setCurrentIndex((prev) => prev + 1);
      setTimeLeft(40); // reset timer for next question
    } else {
      setShowResult(true);
    }

    setIsTransitioning(false);
  }, 300);
};

  const restartQuiz = () => {
    setQuestions(getRandomQuestions(questionsData));
    setCurrentIndex(0);
    setUserAnswer([]);
    setUserAnswers([]);
    setScore(0);
    setShowResult(false);
    setIsTransitioning(false);
  };

  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <h1 className="quiz-title">THE QUIZ APP</h1>
        <p className="quiz-tagline">Test your intelligence</p>
      </div>

      {!showResult ? (
        <QuestionCard
          questionData={questions[currentIndex]}
          questionNumber={currentIndex + 1}
          totalQuestions={questions.length}
          userAnswer={userAnswer}
          setUserAnswer={setUserAnswer}
          onNext={handleNext}
          isTransitioning={isTransitioning}
          timeLeft={timeLeft}

        />
      ) : (
        <Result
          score={score}
          total={questions.length}
          userAnswers={userAnswers}
          onRestart={restartQuiz}
        />
      )}
    </div>
  );
};

export default Quiz;
